import {
  AuthenticateErrorResponse,
  AuthenticateParams,
  AuthenticateSuccessResponse,
  CollaborateLoginParams,
  CollaborateLoginResponse,
  CreateAccountParams,
  CreateAccountResponse,
  LoginApiParams,
  LoginApiResponse,
  RegisterParams,
  RegisterResponse,
  ResendCodeResponse,
  ResetPasswordParams,
  ResetPasswordResponse,
  TrialParams,
  TrialResponse,
  VerifyCodeParams,
  VerifyCodeResponse,
} from 'types/api/login';
import { baseApi } from './baseApi';

export const loginApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    authenticate: builder.query<
      AuthenticateErrorResponse | AuthenticateSuccessResponse,
      AuthenticateParams
    >({
      query: ({ token }) => ({
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        method: 'GET',
        url: '/authenticate',
      }),
    }),
    collaborateLogin: builder.mutation<
      CollaborateLoginResponse,
      CollaborateLoginParams
    >({
      query: (data) => ({
        body: data,
        method: 'POST',
        url: '/collaborate/user/login',
      }),
      invalidatesTags: ['Site'],
    }),
    createAccount: builder.mutation<CreateAccountResponse, CreateAccountParams>(
      {
        query: (data) => ({
          body: data,
          method: 'POST',
          url: '/collaborate/user/create-account',
        }),
      }
    ),
    login: builder.mutation<LoginApiResponse, LoginApiParams>({
      query: (data) => ({
        body: data,
        method: 'POST',
        url: '/api-login',
      }),
    }),
    register: builder.mutation<RegisterResponse, RegisterParams>({
      query: (data) => ({
        body: data,
        method: 'POST',
        url: '/collaborate/user/register',
      }),
    }),
    resendCode: builder.mutation<ResendCodeResponse, void>({
      query: () => ({
        method: 'POST',
        url: '/two-factor-auth/send-code',
      }),
    }),
    resetPassword: builder.mutation<ResetPasswordResponse, ResetPasswordParams>(
      {
        query: (data) => ({
          body: data,
          method: 'POST',
          url: '/api-reset-password-request',
        }),
      }
    ),
    trial: builder.mutation<TrialResponse, TrialParams>({
      query: (data) => ({
        body: data,
        method: 'POST',
        url: '/trial',
      }),
    }),
    verifyCode: builder.mutation<VerifyCodeResponse, VerifyCodeParams>({
      query: (data) => ({
        body: data,
        method: 'POST',
        url: '/two-factor-auth/verify-code',
      }),
    }),
    logout: builder.query<{ status: boolean }, void>({
      query: () => ({
        method: 'GET',
        url: '/logout',
      }),
    }),
  }),
});

export const {
  useAuthenticateQuery,
  useLazyAuthenticateQuery,
  useCollaborateLoginMutation,
  useCreateAccountMutation, // site API, not collaborate
  useLoginMutation, // site API, not collaborate
  useRegisterMutation,
  useResendCodeMutation,
  useResetPasswordMutation,
  useTrialMutation,
  useVerifyCodeMutation,
  useLazyLogoutQuery,
} = loginApi;
